import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isShown: false,
};
const fullPageLoaderSlice = createSlice({
    name: "fullPageLoader",
    initialState,
    reducers: {
        show: (state) => {
            state.isShown = true;
        },
        hide: (state) => {
            state.isShown = false;
        },
    },
});

export default fullPageLoaderSlice.reducer;
export const { show, hide } = fullPageLoaderSlice.actions;
export const fullPageLoaderSelector = () => (state) => state.fullPageLoader.isShown;

export const showLoader = () => async (dispatch) => {
    dispatch(show());
};

export const hideLoader = () => async (dispatch) => {
    dispatch(hide());
};
